import http from './request'

export function getNotificationSummary() {
  return http.get('/notifications/summary')
}
